import React, { HTMLAttributes, useState } from "react";
import { OdsItemFilterDialog } from "../../../dialogs";
import { ItemFilter, ListResult } from "../../../models";
import { ViewHelper } from "../../../services/view-helpers";


export interface OdsItemColumnHeaderProps {
    header: React.ReactNode;
    name: string;
    filter?: ItemFilter;
    sort?: string;
    sortDirection?: string;
    onSortChanged?: (sort: string, sortDirection: string) => void;
    onFilterChanged: (newFilter?: ItemFilter) => void;
    onSearch: (columnName: string, top: number, skip: number, filter: string) => Promise<ListResult<string>>;
}

export const OdsItemColumnHeader: React.FC<OdsItemColumnHeaderProps & HTMLAttributes<HTMLSpanElement>> = ({
    header,
    name,
    filter,
    sort,
    sortDirection,
    onSortChanged,
    onFilterChanged,
    onSearch,
    ...props
}) => {
    const [showFilter, setShowFilter] = useState<boolean>(false);

    const onFilterList = () => {
        setShowFilter(true);
    }

    const onFilterComplete = (dialogResult: boolean, newFilter?: ItemFilter) => {
        setShowFilter(false);
        if (dialogResult) {
            onFilterChanged(newFilter);
        }
    }

    const onDrawSort = (columnName: string) => {
        return ViewHelper.drawSort(columnName, sort, sortDirection, onSortChanged);
    };

    const onDrawFilter = (columnName: string, filtered: boolean) => {
        return ViewHelper.drawFilter(columnName, filtered, onFilterList, onFilterChanged);
    }

    return (
        <th>
            <OdsItemFilterDialog
                header={header}
                show={showFilter}
                filter={filter}
                onSearch={(top, skip, filter) => onSearch(name, top, skip, filter)}
                onComplete={onFilterComplete}
            />
            <span {...props} className={`ods-column-header ${props.className}`}>{header}{onDrawSort(name)}{onDrawFilter(name, !!filter)}</span>
        </th>
    )
};
